import { GrFacebook } from 'react-icons/gr';
import styled from '@emotion/styled';

import { DARK_GRAY } from '../../../styles/constants/color';

const Button = styled.button`
  width: auto;
  height: auto;
  text-align: center;
`;

interface Props {
  color?: string;
}

/**
 *  쏠카 페이스북 링크 버튼 컴포넌트
 * @param {string} color 버튼의 색깔 defalut: #666;
 *  */
function ScFacebook({ color }: Props): JSX.Element {
  const onClick = (): void => {
    window.open('https://www.facebook.com/solecar5012');
  };

  return (
    <Button onClick={onClick}>
      <GrFacebook size={23} color={color || DARK_GRAY} />
    </Button>
  );
}

export default ScFacebook;
